export const getRedirectUri = () => {
  let baseUri: string | null = document.baseURI;
  if (!baseUri) {
    let baseNode = document.querySelector('base');
    if (baseNode) {
      baseUri = baseNode.getAttribute('href');
    }
  }

  let result = baseUri || `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  const hashIndex = result.indexOf('#');
  if (hashIndex !== -1) {
    result = result.substring(0, hashIndex);
  }

  return result.toLowerCase();
}

export function getWindowLocationHost(){
  return window.location.host;
}

export function windowLocationAssign(url: string) {
  window.location.assign(url);
}

export function windowReload(){
  window.location.reload();
}
